import { useEffect, useState } from "react";
import { api } from "../lib/api";

/**
 * Returns { ads, loading, hasAds } for a given (page, slot).
 * Used by public pages to decide whether to render the sidebar column at all.
 */
export default function useAds(page, slot) {
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api.get(`/ads?page=${page}&slot=${slot}`)
      .then((r) => { if (!cancelled) setAds(r.data || []); })
      .catch(() => { if (!cancelled) setAds([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [page, slot]);

  return { ads, loading, hasAds: !loading && ads.length > 0 };
}
